import { Component, Input } from '@angular/core';

import {
    WpViewDistributionData,
    WpViewDistributionTooltipData,
} from '../../../core';

import { TranslationKeyMap } from './progress-bar.component.i18n';

const MIN_PERCENTAGE = 4;

@Component({
    selector: 'cmps-wp-progress-bar',
    templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent {
    @Input() distributionData: WpViewDistributionData[];
    @Input() distributionTooltipData: WpViewDistributionTooltipData[];

    /** @private */ _i18n = TranslationKeyMap;
    /** @private */ _MIN_PERCENTAGE = MIN_PERCENTAGE;
}
